import state from "./moduleTitleState.js";
import mutations from "./moduleTitleMutation.js";
import actions from "./moduleTitleActions.js";
import getters from "./moduleTitleGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
